export default function selectTrelloCardsById(state) {
  return state.integrations.thirdPartyData.trello.cards
}
